import Navbar from "../features/Navbar/Navbar";
import ProductDetails from "../features/Product-List/component/ProductDetails";

function ProductDetailPage() {
    return <div>
        <Navbar/>
      <ProductDetails/>
    </div>;
  }
  export default ProductDetailPage;
  